import React from 'react';
import ProductSubCategoryDetailsFields from './ProductSubCategoryDetailsFields';

function ViewProductSubCategory({ SubCategoryData }) {
  return (
    <div className="card-body px-0">
      <ProductSubCategoryDetailsFields formData={SubCategoryData || {}} readOnly />
    </div>
  );
}

export default ViewProductSubCategory;
